import React, { useState } from "react";
import { Footer, Sidebar } from "../../../../components";
import Dropdowns from "./Dropdowns";
import DashboardContent from "./DashboardContent";

const BroccoliDashboard = ({
  currentOrg,
  setCurrentOrg,
  orgData,
  setOrgData,
  orgLoading,
  setOrgLoading,
  siteData,
  setSiteData,
  currentSite,
  setCurrentSite,
  siteLoading,
  setSiteLoading,
  currentCrop,
  setCurrentCrop,
  cropLoading,
  setCropLoading,
  cropData,
  setCropData,
  searchParams,
  setSearchParams,
  settingDefaults,
  setSettingDefaults,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [siteMetadata, setSiteMetadata] = useState([]);
  const [currentGreenhouse, setCurrentGreenhouse] = useState(null);
  const [currentPlot, setCurrentPlot] = useState(null);
  const [plotData, setPlotData] = useState([]);
  const [greenhouseData, setGreenhouseData] = useState([]);
  const [currentDate, setCurrentDate] = useState(null);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [dateData, setDateData] = useState([]);

  return (
    <>
      <div id="dashboard">
        <Sidebar
          active="home"
          sidebarType="BroccoliGrower"
          open={sidebarOpen}
          setOpen={setSidebarOpen}
        />
        <div
          className={`flex w-full flex-col pb-14 pt-8 lg:pt-6 sm:pt-4 ${
            sidebarOpen ? "pl-[210px] lg:pl-[50px]" : "pl-[50px]"
          } transition-[padding] duration-200 ease-in-out`}
        >
          <div className="mx-auto w-full max-w-[1900px] px-8 xl:px-6 lg:px-3 md:px-2 sm:px-1.5">
            <Dropdowns
              siteMetadata={siteMetadata}
              setSiteMetadata={setSiteMetadata}
              currentOrg={currentOrg}
              setCurrentOrg={setCurrentOrg}
              orgData={orgData}
              setOrgData={setOrgData}
              orgLoading={orgLoading}
              setOrgLoading={setOrgLoading}
              currentSite={currentSite}
              setCurrentSite={setCurrentSite}
              siteData={siteData}
              setSiteData={setSiteData}
              siteLoading={siteLoading}
              setSiteLoading={setSiteLoading}
              currentCrop={currentCrop}
              setCurrentCrop={setCurrentCrop}
              cropData={cropData}
              setCropData={setCropData}
              cropLoading={cropLoading}
              setCropLoading={setCropLoading}
              currentPlot={currentPlot}
              setCurrentPlot={setCurrentPlot}
              currentGreenhouse={currentGreenhouse}
              setCurrentGreenhouse={setCurrentGreenhouse}
              greenhouseData={greenhouseData}
              setGreenhouseData={setGreenhouseData}
              plotData={plotData}
              setPlotData={setPlotData}
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
              setDropdownLoading={setDropdownLoading}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              settingDefaults={settingDefaults}
              setSettingDefaults={setSettingDefaults}
              dateData={dateData}
              setDateData={setDateData}
            />
            {Object.keys(siteMetadata).length === 0 && !dropdownLoading ? (
              <div className="text-2xl text-center">
                Metadata not Configured!
              </div>
            ) : (
              <div className="w-full">
                <DashboardContent
                  currentOrg={currentOrg}
                  currentSite={currentSite}
                  dropdownLoading={dropdownLoading}
                  dateList={dateData}
                  siteMetadata={siteMetadata}
                  currentCrop={currentCrop}
                  currentGreenhouse={currentGreenhouse}
                  currentPlot={currentPlot}
                  currentDate={currentDate}
                />
              </div>
            )}
          </div>
        </div>
        <Footer sidebarOpen={sidebarOpen} />
      </div>
    </>
  );
};

export default BroccoliDashboard;
